import {
  CircularProgress,
  ButtonProps as MuiButtonProps,
  Typography,
  useTheme,
} from '@mui/material';
import { CustomButton } from './styles';

type ButtonProps = {
  text?: string;
  isLoading?: boolean;
} & MuiButtonProps;

export default function Button(props: ButtonProps) {
  const theme = useTheme();
  return (
    <CustomButton {...props} size="large">
      {props.isLoading && (
        <CircularProgress
          size={16}
          sx={{
            mr: 1,
            color: props.disabled
              ? theme.palette['Ambient/Grayscale/Gray-100']
              : theme.palette['Brand/Solid/Primary'],
          }}
        />
      )}

      {props.text ? (
        <Typography variant="Headlines/Small" textTransform="initial">
          {props.text}
        </Typography>
      ) : (
        props.children
      )}
    </CustomButton>
  );
}
